class OrderDetailCombookBinding {
  id: number;
  year: number;
  startMonth: number;
  endMonth: number;
  isIncludePhotos: boolean;
  coverDesignType: string;
  coverDesignTypeText: string;
  coverOrganizationName: string;
  coverKidName: string;
  coverThumbnailUrl: string;
  kidFullName: string;

  constructor(data: {
    id: number;
    year: number;
    startMonth: number;
    endMonth: number;
    isIncludePhotos: boolean;
    coverDesignType: string;
    coverDesignTypeText: string;
    coverOrganizationName: string;
    coverKidName: string;
    coverThumbnailUrl: string;
    kidFullName?: string;
  }) {
    this.id = data.id;
    this.year = data.year;
    this.startMonth = data.startMonth;
    this.endMonth = data.endMonth;
    this.isIncludePhotos = data.isIncludePhotos;
    this.coverDesignType = data.coverDesignType;
    this.coverDesignTypeText = data.coverDesignTypeText;
    this.coverOrganizationName = data.coverOrganizationName;
    this.coverKidName = data.coverKidName;
    this.coverThumbnailUrl = data.coverThumbnailUrl;
    this.kidFullName = data.kidFullName || "";
  }

  get uniqueKey(): string {
    return `orderDetailCombookBinding-${this.id}`;
  }
}

export default OrderDetailCombookBinding;
